import { ALLOWED_MIME_TYPES, MAX_FILE_SIZE } from "../../helper";

export const validateFilesWithErrors = (
  fileList: FileList | File[],
  allowedMimeTypes = ALLOWED_MIME_TYPES,
  maxFileSize = MAX_FILE_SIZE
): { validFiles: File[]; errors: string[] } => {
  const files = Array.from(fileList || []);
  const errors: string[] = [];

  const validFiles = files.filter((file) => {
    const isValidType = allowedMimeTypes.includes(file.type);
    const isValidSize = file.size <= maxFileSize;

    if (!isValidType) {
      errors.push(`Invalid file: ${file.name}`);
    }
    if (!isValidSize) {
      errors.push(`File too large: ${file.name} (${(file.size / 1024 / 1024).toFixed(2)} MB)`);
    }

    return isValidType && isValidSize;
  });

  return { validFiles, errors };
};

export const getReadableFileSize = (size: number): string => {
  if (size >= 1024 * 1024) {
    return (size / (1024 * 1024)).toFixed(2) + ' MB';
  } else if (size >= 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  } else {
    return size + ' Bytes';
  }
};